import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient";
import { getErrorMessage } from "#/utils/APIUtils";

const baseUrl = "/api/dog/testna_postaja/naselitev";

export const fetchSettlementPage = createAsyncThunk(
  "settlement/page",
  async ({ page, filter, sort }, { rejectWithValue }) => {
    try {
      const response = await ApiClient.get(
        `${baseUrl}/page`,
        undefined,
        page,
        filter,
        sort,
        false
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const createSettlement = createAsyncThunk(
  "settlement/create",
  async (settlement, { rejectWithValue }) => {
    try {
      const response = await ApiClient.post(baseUrl, settlement);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

const settlementSlice = createSlice({
  name: "settlement",
  initialState: {
    details: null,
    page: null,
    error: null,
    isLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSettlementPage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.page = action.payload;
      })
      .addCase(fetchSettlementPage.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchSettlementPage.pending, (state, _action) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createSettlement.fulfilled, (state, _) => {
        state.isLoading = false;
      })
      .addCase(createSettlement.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(createSettlement.pending, (state, _) => {
        state.isLoading = true;
        state.error = null;
      });
  },
});

export default settlementSlice.reducer;
